<template>
  <div id="app">
    <!-- <t-index></t-index> -->
    <router-view/>
    <!-- <m-header></m-header>
    <keep-alive>
    </keep-alive> -->
  </div>
</template>

<script>
// import TIndex from 'components/tIndex/tIndex'
export default {
  name: 'App',
  // components: {
  //   TIndex
  // },
  mounted () {
    this.adapterDevice()
    // window.addEventListener('resize', () => {
    //   this.adapterDevice()
    // })
  },
  methods: {
    adapterDevice () {
      if (!(/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent))) {
        // pc
        this.$router.push({
          path: '/pc/home'
        })
      } else {
        // 移动
        this.$router.push({
          path: '/ter/home'
        })
      }
    }
  }
}
</script>

<style>
/* img[lazy=loading] {
  width: auto !important;
  height: 100% !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue